import type {
	allBuyersInput,
	allProxiesInput,
	allSellersInput,
	allSenderGroupNamesInput,
	getIdFromNameInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface Keys {
	useGetAllBuyers: allBuyersInput;
	useGetAllSellers: allSellersInput;
	useGetAllGroups: allSenderGroupNamesInput;
	useGetAllProxies: allProxiesInput;
	useGetIdFromName: getIdFromNameInput;
	useOriginStatus: "useOriginStatus";
}

const GENERAL_SERVICE_KEYS = createReactQueryKeys<Keys>("general", [
	"useGetAllBuyers",
	"useGetAllSellers",
	"useGetAllGroups",
	"useGetAllProxies",
	"useGetIdFromName",
	"useOriginStatus",
]);

export { GENERAL_SERVICE_KEYS };
